import React from 'react';
import {Button, Result} from 'antd';
import {useNavigate} from 'react-router-dom';
import { useTranslation } from '../hooks/useTranslation';

const NotFound: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className="not-found-page" style={{ 
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center', 
      minHeight: '60vh' 
    }}>
      <Result
        status="404"
        title={t('notFound.title')}
        subTitle={t('notFound.subTitle')}
        extra={[
          <Button type="primary" key="home" onClick={() => navigate('/')}>
            {t('notFound.backHome')}
          </Button>,
          <Button key="back" onClick={() => navigate(-1)}>
            {t('notFound.goBack')}
          </Button>,
        ]}
      />
    </div>
  );
};

export default NotFound; 